<div class="container-fluid h-100">
  <div class="row h-100" style="overflow-y: auto;">

 
    <div class="col-12 col-md-3 border-end d-flex flex-column" style="height: 91vh;padding: 0px;">

      <div class="regionHead border-bottom">
        <div class="d-flex justify-content-between align-items-center ">
          <span><b>Region</b></span>

        </div>
      </div>


      <div class="flex-grow-1 overflow-auto  border-bottom" style="max-height: calc(100% - 170px); ">
        <div *ngFor="let item of displayregioncontent" (click)="storeidfun(item.regionId)">
          <div [ngClass]="{ 'highlighted-region': expandedRegionId === item.regionId }">
            <div class="hoverpart">
              <div class="g-0 d-flex justify-content-between py-2"
                (click)="showafica(item.regionId); $event.stopPropagation()" style="padding-inline: 1rem;">
                <span class="d-flex gap-2 align-items-center" style="margin-bottom: 15px; ">
                  <img class="rightpaddingapply" *ngIf="expandedRegionId !== item.regionId"
                    src="assets/content-manager/LocIcon.svg">
                  <img class="rightpaddingapply" *ngIf="expandedRegionId === item.regionId"
                    src="assets/content-manager/selectedLoc.svg">
                  <p class="text-truncate mb-0" style="cursor: pointer;font-weight: 400; max-width: 200px;"
                    (click)="showafica(item.regionId); $event.stopPropagation()" >
                    {{ item.regionName }}
                  </p>
                </span>
                <div class="imgs">
                  <img *ngIf="expandedRegionId === item.regionId"
                    (click)="showafica(item.regionId); $event.stopPropagation()"
                    src="assets/content-manager/Downarrow.svg" style="cursor: pointer;">
                  <img *ngIf="expandedRegionId !== item.regionId"
                    (click)="showafica(item.regionId); $event.stopPropagation()"
                    src="assets/content-manager/Uparrow.svg" style="cursor: pointer;">
                  <div *ngIf="expandedRegionId === item.regionId  && (item.subRegions && item.subRegions.length > 0)"
                    class="sky-blue"></div>
                </div>

              </div>

            </div>
          </div>
          <div class="borderline" style="border-left: 7px solid #B0E0E6;">
            <ul *ngIf="expandedRegionId === item.regionId" class="region-list list-unstyled" id="showw">


              <div class="subregion-scroll">
                <div *ngFor="let subinfo of item.subRegions"
                  (click)="storesubid(subinfo.subRegionId); showsubrigion(subinfo.subRegionId)"
                  class="d-flex justify-content-between align-items-center subhover"
                  [ngClass]="{ 'subregionselected': expandedsubRegionId === subinfo.subRegionId }"
                  style="padding-inline: 1rem;">

                  <div class="d-flex align-items-center reginimg">
                    <img *ngIf="expandedRegionId === item.regionId" class="adjust-arrow"
                      src="assets/content-manager/FarrowHead.svg">
                    <p *ngIf="!item.subRegions || item.subRegions.length === 0"> No </p>

                    <div class="lis">
                      <li style="cursor: pointer; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                        (click)="showsubrigion(subinfo.subRegionId); $event.stopPropagation()">
                        <p
                          style="font-weight: 480; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 10rem;">
                          {{ subinfo.subRegionName }}
                        </p>
                      </li>
                    </div>
                  </div>

                  <span>
                    <img (click)="showsubrigion(subinfo.subRegionId); showeditsubregion(); $event.stopPropagation()"
                      class="arr" src="assets/content-manager/bluePencil.svg" style="cursor: pointer">
                  </span>
                </div>
              </div>


            </ul>
          </div>


        </div>
      </div>

     

      <div class="AddRegionWrapper">
        <button (click)="Addnewregion()" class="addregonbutton flex-shrink-0 ">Add New Region</button>
      </div>
    </div>





    <div class="col-12 col-md-6 border-end d-flex flex-column" style="height: 91vh; padding: 0;">
      <div class="appreview"><span>App Preview</span></div>

      <div class="Outer-Main-card-wrapper">
        <div *ngIf="showmaincontent" class="inner-main-cards-wrapper">

          <div class="main-card-wrapper">

            <div *ngFor="let item of displayregioncontent" style="padding-inline: 2rem;">
              <div class="d-flex justify-content-center align-items-center card-main flex-wrap gap-3 mt-2">

                <div style="margin-bottom: 10px;" class="card w-100 position-relative overflow-hidden" id="maincardss">
                  <div class="image-wrapper position-relative">
                    <img (click)="showafica(item.regionId); $event.stopPropagation()" [src]="item.regionDisplayImageUrl"
                      alt="{{item.regionName}}" class="img-fluid w-100 vintage-img" />
                    <div class="vintage-overlay"></div>
                  </div>
                  <div class="card-body text-truncate" style="max-width: 300px;">{{ item.regionName }}</div>
                </div>

              </div>
            </div>

          </div>
        </div>

        <div style=" ">
          <div *ngFor="let item of displayregioncontent">
            <div *ngIf="showAfrica && expandedRegionId === item.regionId" class="d-flex justify-content-center"
              style="height: calc(91vh - 70px); ">
              <div class="card" id="maincard">
                <div class="d-flex justify-content-center align-items-center card-main flex-wrap">

                  <div class="card w-100" id="cards">
                    <div class="vintage-overlay"></div>
                    <img src="{{item.regionDisplayImageUrl}}" class="img-fluid w-100">
                    <div class="card-body text-truncate" style="max-width: 300px;">{{item.regionName}}</div>
                  </div>
                </div>

                <div class="location-container d-flex flex-column">
                  <div class="d-flex flex-column locationcard">
                    <div class="d-flex align-items-center gap-2 border-bottom py-2"
                      *ngFor="let subname of item.subRegions" (click)="storesubid(subname.subRegionId)">
                      <p><img src="assets/content-manager/LocIcon.svg"></p>
                      <p style="cursor: pointer;font-weight: 600;color: #000000;"
                        (click)="showsubrigion(subname.subRegionId); $event.stopPropagation()" class="namecity">
                        {{ subname.subRegionName }}
                      </p>
                      <p style="cursor: pointer;"
                        (click)="showsubrigion(subname.subRegionId); $event.stopPropagation()">
                        <img src="assets/content-manager/blacktriangle.svg">
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div *ngFor="let item of displayregioncontent">
          <ng-container *ngFor="let subname of item.subRegions">
            <ng-container *ngIf="shoaddloc && expandedsubRegionId === subname.subRegionId">
              <div class="displayregioncontent">
                <div class="subname">
                  <div class="location-item-wrapper">
                          <div *ngIf="subname.locations?.length === 0 " class="h-100 d-flex align-items-center justify-content-center" >
                          <h5>No Location Added For Selected Subregion</h5>
                        </div>
                    <div *ngFor="let loc of subname.locations" class="Location-item">
                      <div class="d-flex justify-content-center align-items-center flex-wrap gap-3">
                        <div class="card w-100" id="subcart">
                          <img src="{{loc.locationDisplayImageUrl}}" alt="Cairo" class="img-fluid w-100">
                          <div class="card-body">{{loc.locationName}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>

      </div>
    </div>


    <div class="col-12 col-md-3 d-flex flex-column" style="height: 91vh; padding: 0;">
      <div class=" settings">
        <img src="assets/content-manager/settingIcon.svg" alt="Settings" class="me-2">
        <p class="mb-0" style="font-weight: 600;">Settings</p>
      </div>

      <div class="setting-content-wrapper">

        <div *ngIf="showmaincontent && !Addregion" class="text-center text-muted d-flex align-items-center h-100"
          style="color: #6D6D6D; font-size: larger;">
          <p *ngIf="!Addregion">No region selected. Select a region to make changes in settings.</p>
        </div>

        <div class="setting-inner-wrapper" >
          <div class="" >
            <div *ngIf="Addregion" class="" style=" padding: 1rem;">
              <label class="form-label fw-bold ">Add new Region</label>
              <input type="text" class="form-control mb-3" [(ngModel)]="AddNewRegion.regionName">
              <div class="card text-center py-3 " style="cursor: pointer;" id="secondregioncard">
                <img *ngIf="regionurl" src="assets/content-manager/cross.svg" (click)="kepnullregion()"
                  class="position-absolute"
                  style="top: 6px; right: 6px; height: 18px; width: 18px; cursor: pointer; z-index: 10;">
                <img *ngIf="regionurl" src="{{regionurl}}" class="img-fluid w-100" id="imgregionp">

                <div class="addimges">
                  <img src="assets/content-manager/addimg.svg" style="height: 39px;width: 39px;">
                  <p *ngIf="!regionurl" (click)="fileInput.click()" class="text-info" style="margin-top: 10px;">
                    <strong>Add image</strong>
                  </p>

                  <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event)" hidden />
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="AddnewSubregion" class= "border-bottom" style="height: 100%; padding: 1rem;">
            <div >
              <label class="form-label fw-bold">Add new Subregion</label>
              <input type="text" class="form-control" [(ngModel)]="Addsubrigions.subRegionName">
            </div>
          </div>

          <div *ngIf="Addnewlocatin" class="border-bottom" style="height: 100%; padding: 1rem;">
            <div class="mb-4">
              <label class="form-label fw-bold">Add new Location</label>
              <input type="text" class="form-control mb-3" [(ngModel)]="AddLocationobj.locationName">
        <div>
  <label class="form-label fw-bold">Location Longitude</label>
  <input 
    type="text"  
    class="form-control mb-1"
    [(ngModel)]="AddLocationobj.langitude"
    name="longitude"
    #longitude="ngModel"
    required
  >
  <div class="text-danger small" *ngIf="longitude.invalid && longitude.touched">
    Longitude is required
  </div>

  <label class="form-label fw-bold mt-3">Location Latitude</label>
  <input 
    type="text"  
    class="form-control mb-1"
    [(ngModel)]="AddLocationobj.latitude"
    name="latitude"
    #latitude="ngModel"
    required
  >
  <div class="text-danger small" *ngIf="latitude.invalid && latitude.touched">
    Latitude is required
  </div>
</div>

                
              <div class="card text-center py-3 " style="cursor: pointer;" id="cardsecond">

                <img *ngIf="locationurl" src="assets/content-manager/cross.svg" (click)="kepnull()"
                  class="position-absolute"
                  style="top: 6px; right: 6px; height: 18px; width: 18px; cursor: pointer; z-index: 10;">

                <img *ngIf="locationurl" src="{{locationurl}}" class="img-fluid w-122" id="eimglocxx">
                <div class="addimges">
                  <img src="assets/content-manager/addimg.svg" style="height: 39px;width: 39px;">
                  <p *ngIf="!locationurl" (click)="fileInput.click()" class="text-info" style="margin-top: 10px;">
                    <strong>Add image</strong>
                  </p>

                  <input type="file" #fileInput accept="image/*"
                    (change)="onlocFileSelected($event,AddLocationobj.locationId)" hidden />
                </div>
              </div>
            </div>
          </div>  


            <div *ngIf="subafrica" class="subafrica" style="height: 100%;">
              <div *ngFor="let item of displayregioncontent">
                <div *ngIf="expandedRegionId === item.regionId" class="subafrica2"
                  style="height: calc(91vh - (150px + 70px)); overflow-y: auto;">
                  <div class="region-internal">
                    <div class="region-internal-wrapper">
                      <label class="form-label fw-bold" id="regioninfo">REGION</label>
                      <div class="d-flex">
                        <input *ngIf="!editname" class="form-control mb-3" placeholder="{{ item.regionName }}" readonly
                          [ngClass]="editimage ? 'image-full' : 'name-dimmed'">
                        <span *ngIf="showedit && !editname" (click)="Editname()">
                          <img src="assets/content-manager/Add.png">
                        </span>
                      </div>

                      <input *ngIf="showedit && editname" placeholder="{{item.regionName}}" type="text"
                        class="form-control mb-3" [(ngModel)]="AddNewRegion.regionName">

                      <div class="d-flex" style="height: 135px">
                        <div *ngIf="!hideimgregion" class="region-info-card mb-2 shadow-sm border-0" id="card2">
                          <img [src]="item.regionDisplayImageUrl" alt="{{ item.regionName }}" class="card-img-top"
                            [ngClass]="editimage ? 'image-full' : 'image-dimmed'">
                          <div class="card-body text-center p-3" id="cardbodynames">
                            <h5 class="region-name mb-0">{{ item.regionName }}</h5>
                          </div>
                        </div>

                        <div *ngIf="hideimgregion" class="cardRegion text-center py-3" style="cursor: pointer;" id="sssss">
                          <img *ngIf="regionurl" src="assets/content-manager/cross.svg" (click)="kepnullregion()"
                            class="position-absolute"
                            style="top: 6px; right: 6px; height: 18px; width: 18px; cursor: pointer; z-index: 10;">
                          <img *ngIf="regionurl" [src]="regionurl" class="img-fluid w-100" id="eimgregionpp">
                          <img *ngIf="!regionurl" [src]="item.regionDisplayImageUrl" class="img-fluid w-100"
                            id="eimgregionp">
                        </div>

                        <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event)" hidden />
                        <span *ngIf="showedit" (click)="showaddimgfun();fileInput.click()">
                          <img class="editimg" src="assets/content-manager/edit.svg">
                        </span>
                      </div>
                    </div>
                    <hr>

                    <div class="subregion-internal-wrapper">
                      <div style="height: 45px; ">
                        <p class="fw-bold mt-3" id="subregionname">SUBREGION</p>
                      </div>

                      <div cdkDropList (cdkDropListDropped)="dropSubregion($event, item.subRegions)"
                        class="w-100 subpartscroll">
                        <div *ngFor="let subname of item.subRegions" cdkDrag class="d-flex align-items-center mb-2">
                          <span *ngIf="showedit" class="me-2" cdkDragHandle>
                            <img (click)="updatesuborder()" src="assets/content-manager/dot.svg" style="cursor: move;">
                          </span>
                          <span *ngIf="!showedit" class="me-2" style="width: 24px;"></span>
                          <input id="namedits" style="color: #6D6D6D;" class="form-control me-2"
                            [value]="subname.subRegionName" readonly
                            [ngClass]="editimage ? 'image-full' : 'name-dimmed'">
                          <span *ngIf="showedit" (click)="deletesubrigion(subname.subRegionId, subname.subRegionName)"
                            class="me-2">
                            <img src="assets/content-manager/cross.svg" style="cursor: pointer;">
                          </span>
                        </div>

                        <div class="noregionmsg" *ngIf="!item.subRegions || item.subRegions.length === 0">
                          <p>No Subregion Added</p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>


            <div *ngIf="showsubrigin" class="Sub-Loc-Wrapper" id="subregionpartss">

              <div *ngFor="let item of displayregioncontent">
                <div *ngFor="let subname of item.subRegions">

                  <div *ngIf="expandedsubRegionId === subname.subRegionId" class="mb-4" id="bottompart" style="height: calc(91vh - (70px + 153px));
                     overflow-y: auto;">
                    <div class="subregion-head-wrapper">
                      <p class="fw-bold">Subregion</p>
                      <div class="d-flex justify-content-center align-items-center ">
                        <input *ngIf="!editsubrigionname" class="form-control mb-2 bg-light text-muted"
                          [placeholder]="subname.subRegionName" readonly style="width: 98%;">
                        <input type="text" *ngIf="editsubregion && editsubrigionname "
                          [placeholder]="subname.subRegionName" class="form-control"
                          [(ngModel)]="Addsubrigions.subRegionName" style="width: 98%;">
                      </div>
                    </div>




                    <div style="    height: calc(100% - 100px);">
                      <div style="    
                                   height: 30px;
                           display: flex
                                  ;     
                                       align-items: center;
                                            ">
                        <p class="fw-bold mb-1">Location</p>
                      </div>
                      <div cdkDropList (cdkDropListDropped)="drop(subname.locations, $event)" class="locationcard">
                        <div *ngFor="let loc of subname.locations; let i = index" cdkDrag
                          class="mb-3 location-item  p-2">
                          <div class="d-flex align-items-center mb-2">

                            <span *ngIf="editsubregion" class="me-2 cdkDragHandle" style="cursor: move;">
                              <img (click)="updatelocationorder()" src="assets/content-manager/dot.svg">
                            </span>




                            <input type="text" class="form-control me-2" [(ngModel)]="loc.locationName"
                              [readonly]="!isEditing" placeholder="Enter location name"
                              (ngModelChange)="onLocationNameChange(loc)"
                              [ngStyle]="!isEditing ? {'background-color': '#E7E7E7', 'color': '#6D6D6D', 'border-radius': '16px'} : {}" />


                            
            




                            <span *ngIf="editsubregion" class="d-flex gap-2">
                              <img src="assets/content-manager/cross.svg"
                                (click)="deletelocation(loc.locationId,loc.locationName)">


                            </span>
                          </div>
<label class="form-label" [ngStyle]="!isEditing ? {'color': '#6D6D6D'} : {'font-weight':'500'}">
  Location Longitude
</label>
<input type="text"
       required
       (ngModelChange)="onLangitudeChange(loc)"
       [readonly]="!isEditing"
       [(ngModel)]="loc.langitude"
       #longitude="ngModel"
       [ngStyle]="!isEditing ? {'background-color': '#E7E7E7', 'color': '#6D6D6D', 'border-radius': '16px'} : {}"
       class="form-control mb-1">

<div *ngIf="longitude.invalid && longitude.touched" class="text-danger">
  Longitude is required
</div>


<label class="form-label" [ngStyle]="!isEditing ? {'color': '#6D6D6D'} :{'font-weight':'500'}">
  Location Latitude
</label>
<input type="text"
       required
       (ngModelChange)="onlatitudeChange(loc)"
       [readonly]="!isEditing"
       [(ngModel)]="loc.latitude"
       #latitude="ngModel"
       [ngStyle]="!isEditing ? {'background-color': '#E7E7E7', 'color': '#6D6D6D', 'border-radius': '16px'} : {}"
       class="form-control mb-1">

<div *ngIf="latitude.invalid && latitude.touched" class="text-danger">
  Latitude is required
</div>



                          <div class="d-flex align-items-center">
                            <div class="card me-2" id="secondcard">
                              <div class="card-body">

                                <img *ngIf="locationPreviewUrls[loc.locationId]"
                                  [src]="locationPreviewUrls[loc.locationId]" class="img-fluid w-100 rounded"
                                  id="eimgloc">


                                <img *ngIf="!locationPreviewUrls[loc.locationId] " [src]="loc.locationDisplayImageUrl"
                                  class="img-fluid" id="locationp"
                                  [ngClass]="editimage ? 'image-full' : 'image-dimmed'">
                              </div>
                            </div>


                            <span *ngIf="editsubregion" class="editmaincard d-flex gap-2 align-items-center">
                              <input type="file" #fileInput accept="image/*"
                                (change)="onlocFileSelected($event, loc.locationId)" hidden />
                              <img class="Addeditcard" src="assets/content-manager/edit.svg"
                                (click)="locationupdatepart(loc.locationId, loc.locationName); fileInput.click()" />

                            </span>

                          </div>






                        </div>
                        <div *ngIf="subname.locations?.length === 0 " class="h-100 d-flex align-items-center justify-content-center" >
                          <span>No Location Added For Selected Subregion</span>
                        </div>
                      </div>
                    </div>




                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="setting-buttons-wrapper" >
            <div *ngIf="Addregion" class="d-flex flex-column gap-2">
        <button
  class="btn btn-primary button-region"
  (click)="AddRegionpost()"
  [disabled]="isRegionSaving">

  <ng-container *ngIf="!isRegionSaving">
    Save
  </ng-container>

  <ng-container *ngIf="isRegionSaving">
    <span
      class="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true">
    </span>
    Saving...
  </ng-container>

</button>

              <button class="deleteregion-btn" style="background-color: #fff5f5;"
                (click)="Addnewregion()">Cancel</button>
            </div>

            <div *ngIf="subafrica && selectedRegion && !showedit" class="d-flex flex-column gap-2" id="threebtn">
              <button class="button-region" (click)="showeditfunction();Editname()">Edit this Region</button>
              <button class="button-region" (click)="showAddnewsubregion()">Add New Subregion</button>
              <button class="deleteregion-btn" style="background-color: #fff5f5;" (click)="deleteregion()">Delete this
                Region</button>
            </div>

            <div *ngIf="showedit" class="d-flex flex-column gap-2">
              <button class="button-region" (click)="updatesuborder();nameAddRegionpost();">Save Change</button>
              <button class="deleteregion-btn" style="background-color: #fff5f5;"
                (click)="backtoregion();oncancel()">Cancel</button>
            </div>

            <div *ngIf="showlocation && !editsubregion" class="d-flex flex-column gap-2" id="location">
              <button class="button-region" (click)="AddnewLocation()">Add new location</button>
              <button class="button-region" (click)="showeditsubregion()">Edit subregion</button>
              <button class="deleteregion-btn" style="background-color: #fff5f5;" (click)="BacktoSubrigion()">Back To
                Subregion</button>
            </div>

            <div *ngIf="Addnewlocatin" class="d-flex flex-column gap-2">
<button
  class="btn btn-primary button-region"
  (click)="AddnewLocations()"
  [disabled]="isSaving">

  <ng-container *ngIf="!isSaving">
    Save
  </ng-container>

  <ng-container *ngIf="isSaving">
    <span
      class="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true">
    </span>
    Saving...
  </ng-container>

</button>

              <button class="deleteregion-btn" style="background-color: #fff5f5;"
                (click)="backtosubrigion()">Cancel</button>
            </div>

            <div *ngIf="editsubregion" class="d-flex flex-column gap-2">

              <button class="button-region" (click)="updatelocationorder();UpdateNewLocation();">Save</button>
              <button class="deleteregion-btn" style="background-color: #fff5f5;"
                (click)="backtolocation()">Cancel</button>
            </div>

            <div *ngIf="AddnewSubregion" class="d-flex flex-column gap-2">
              <button class="button-region" (click)="Addsubrigionfun()">Save Changes</button>
              <button class="deleteregion-btn" style="background-color: #fff5f5;"
                (click)="backtoregion()">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>